import _slicedToArray from "/runner/_work/3pp/3pp/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/runner/_work/3pp/3pp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/runner/_work/3pp/3pp/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _taggedTemplateLiteral from "/runner/_work/3pp/3pp/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject89() {
  var data = _taggedTemplateLiteral(["\n  color: #989898;\n  font-size: 14px;\n  line-height: 19px;\n  touch-action: none;\n  line-height: 19px;\n  margin-left: 10px;\n  border: none;\n  width: 100%;\n"]);

  _templateObject89 = function _templateObject89() {
    return data;
  };

  return data;
}

function _templateObject88() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  border: 1px solid #E8E8E8;\n  height: 40px;\n  padding: 13px;\n  box-sizing: border-box;\n  border-radius: 4px;\n  background-color: #F5F5F5;\n  color: #989898;\n  overflow: hidden;\n  align-items: center;\n"]);

  _templateObject88 = function _templateObject88() {
    return data;
  };

  return data;
}

function _templateObject87() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"]);

  _templateObject87 = function _templateObject87() {
    return data;
  };

  return data;
}

function _templateObject86() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject86 = function _templateObject86() {
    return data;
  };

  return data;
}

function _templateObject85() {
  var data = _taggedTemplateLiteral(["\n  padding: 8px;\n  float: right;\n"]);

  _templateObject85 = function _templateObject85() {
    return data;
  };

  return data;
}

function _templateObject84() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 11;\n"]);

  _templateObject84 = function _templateObject84() {
    return data;
  };

  return data;
}

function _templateObject83() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  left: 50%;\n  width: 100%;\n  padding: 8px 16px 16px 16px;\n  background-color: white;\n  border-top-left-radius: 12px;\n  box-shadow: 0 -10px 10px 0 rgba(152,152,152,0.20);\n  border-top-right-radius: 12px;\n  max-width: 480px;\n  transform: translate(-50%, 0);\n  z-index: 12;\n"]);

  _templateObject83 = function _templateObject83() {
    return data;
  };

  return data;
}

function _templateObject82() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  margin: 8px 0;\n  .asterisk {\n    color: ", ";\n  }\n"]);

  _templateObject82 = function _templateObject82() {
    return data;
  };

  return data;
}

function _templateObject81() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 16px;\n  h4 {\n    font-size: 14px;\n    margin: 0;\n  }\n  p {\n    font-size: 12px;\n    margin: 4px 0 0 0;\n    &::after {\n      content: '*';\n      color: ", ";\n      display: ", "\n    }\n  }\n"]);

  _templateObject81 = function _templateObject81() {
    return data;
  };

  return data;
}

function _templateObject80() {
  var data = _taggedTemplateLiteral(["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  li {\n  display: flex;\n  margin-bottom: 20px;\n    img {\n      width: 48px;\n      height: 48px;\n    }\n  }\n"]);

  _templateObject80 = function _templateObject80() {
    return data;
  };

  return data;
}

function _templateObject79() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  img {\n    max-height: 26px;\n  }\n  .head-title {\n    font-size: 12px;\n  }\n"]);

  _templateObject79 = function _templateObject79() {
    return data;
  };

  return data;
}

function _templateObject78() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n"]);

  _templateObject78 = function _templateObject78() {
    return data;
  };

  return data;
}

function _templateObject77() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 16px;\n  width: 48px;\n  > img {\n    max-width: 48px;\n  }\n"]);

  _templateObject77 = function _templateObject77() {
    return data;
  };

  return data;
}

function _templateObject76() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  font-size: 16px;\n  font-weight: bold;\n"]);

  _templateObject76 = function _templateObject76() {
    return data;
  };

  return data;
}

function _templateObject75() {
  var data = _taggedTemplateLiteral(["\n  margin: 1em 0;\n  display: flex;\n  justify-content: space-between;\n  color: ", ";\n  font-size: 12px;\n"]);

  _templateObject75 = function _templateObject75() {
    return data;
  };

  return data;
}

function _templateObject74() {
  var data = _taggedTemplateLiteral(["\n  border-top: 1px solid #E3E3E3;\n  margin: 20px 0;\n  borderBottom: none;\n"]);

  _templateObject74 = function _templateObject74() {
    return data;
  };

  return data;
}

function _templateObject73() {
  var data = _taggedTemplateLiteral(["\n  padding: 5px 0;\n"]);

  _templateObject73 = function _templateObject73() {
    return data;
  };

  return data;
}

function _templateObject72() {
  var data = _taggedTemplateLiteral(["\n  h4 {\n    margin: -4px 0 0 0;\n    font-weight: 600;\n  }\n  p {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-weight: 400;\n    line-height: 1.5;\n  }\n  .learn-more {\n    color: ", ";\n    border-bottom: 1px dashed #00aeef;\n  }\n"]);

  _templateObject72 = function _templateObject72() {
    return data;
  };

  return data;
}

function _templateObject71() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: ", ";\n"]);

  _templateObject71 = function _templateObject71() {
    return data;
  };

  return data;
}

function _templateObject70() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  padding: 16px;\n  margin: 20px 0;\n  border-radius: 4px;\n  font-size: 12px;\n  transition: all .25s ease;\n"]);

  _templateObject70 = function _templateObject70() {
    return data;
  };

  return data;
}

function _templateObject69() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  &:checked + ", " {\n    background-color: #01ABEB;\n    color: white;\n    border-color: #01ABEB;\n  }\n"]);

  _templateObject69 = function _templateObject69() {
    return data;
  };

  return data;
}

function _templateObject68() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 17px;\n  height: 17px;\n  background-color: white;\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n  color: transparent;\n  transition: all .25s ease;\n  &:hover {\n      background-color: #eff2f7;\n  }\n"]);

  _templateObject68 = function _templateObject68() {
    return data;
  };

  return data;
}

function _templateObject67() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject67 = function _templateObject67() {
    return data;
  };

  return data;
}

function _templateObject66() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  display: flex;\n  margin-right: 1.5em;\n  cursor: pointer;\n  position: relative;\n"]);

  _templateObject66 = function _templateObject66() {
    return data;
  };

  return data;
}

function _templateObject65() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin: 0 auto;\n  max-width: 480px;\n  height: 100%;\n  padding: 0 1em;\n  z-index: 2;\n  position: relative;\n"]);

  _templateObject65 = function _templateObject65() {
    return data;
  };

  return data;
}

function _templateObject64() {
  var data = _taggedTemplateLiteral(["\n  color: #4A4A4A;\n  font-size: 16px;\n  margin: 0;\n  line-height: 22px;\n"]);

  _templateObject64 = function _templateObject64() {
    return data;
  };

  return data;
}

function _templateObject63() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  top: 0;\n  left: 0;\n  z-index: 11;\n  height: 50px;\n  position: fixed;\n  background: #fff;\n  border-bottom: 1px solid #e8e8e8;\n"]);

  _templateObject63 = function _templateObject63() {
    return data;
  };

  return data;
}

function _templateObject62() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 2rem;\n  width: 100%;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  padding-left: 0px;\n  padding-right: 0px;\n  background-color: #10A8E5;\n  color: #fff;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 600;\n  border-radius: 0.25rem;\n  border: none;\n"]);

  _templateObject62 = function _templateObject62() {
    return data;
  };

  return data;
}

function _templateObject61() {
  var data = _taggedTemplateLiteral(["\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  padding: 0 3rem;\n"]);

  _templateObject61 = function _templateObject61() {
    return data;
  };

  return data;
}

function _templateObject60() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 600;\n  margin-top: 1.25rem;\n  margin-bottom: 1.25rem;\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n"]);

  _templateObject60 = function _templateObject60() {
    return data;
  };

  return data;
}

function _templateObject59() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n"]);

  _templateObject59 = function _templateObject59() {
    return data;
  };

  return data;
}

function _templateObject58() {
  var data = _taggedTemplateLiteral(["\n  max-width: 24rem;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n  justify-content: center;\n  color: #3A3A3A;\n"]);

  _templateObject58 = function _templateObject58() {
    return data;
  };

  return data;
}

function _templateObject57() {
  var data = _taggedTemplateLiteral(["\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  align-content: center;\n  justify-content: center;\n"]);

  _templateObject57 = function _templateObject57() {
    return data;
  };

  return data;
}

function _templateObject56() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject56 = function _templateObject56() {
    return data;
  };

  return data;
}

function _templateObject55() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  textarea {\n    width: 100%;\n    min-height: 70px;\n    height: 100%;\n    font-family: inherit;\n    padding: 0.5em;\n    border-width: 1px;\n    border-style: solid;\n    border-color: rgb(204, 208, 211);\n    border-image: initial;\n    background: rgb(255, 255, 255);\n    border-radius: 5px;\n    resize: none;\n  }\n  span {\n    color: rgb(198, 198, 198);\n    font-size: 10px;\n    line-height: 16px;\n    position: absolute;\n    right: 10px;\n    bottom: 7px;\n  }\n"]);

  _templateObject55 = function _templateObject55() {
    return data;
  };

  return data;
}

function _templateObject54() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject54 = function _templateObject54() {
    return data;
  };

  return data;
}

function _templateObject53() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 19px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: #B1B1B1;\n\n  label {\n    display: flex;\n    -webkit-box-pack: justify;\n    justify-content: space-between;\n    margin: 10px 0px;\n    line-height: 22px;\n    width: 100%;\n  }\n\n  input {\n    opacity: 0;\n    width: 0px;\n    height: 0px;\n  }\n\n  input:checked + span {\n    background-color: rgb(127, 215, 247)\n  }\n\n  span {\n    margin-top: 5px;\n    margin-right: 10px;\n    position: relative;\n    cursor: pointer;\n    width: 34px;\n    height: 14px;\n    background-color: rgba(34, 31, 31, 0.26);\n    flex-shrink: 0;\n    transition: all 0.35s ease 0s;\n    border-radius: 34px;\n    &:focus {\n      &::before {\n        outline: none;\n      }\n    }\n  }\n\n  input:checked + span::before {\n    transform: translateX(26px);\n    background-color: rgb(0, 175, 239);\n  }\n\n  span::before {\n    outline: none;\n    position: absolute;\n    content: \"\";\n    height: 20px;\n    width: 20px;\n    left: -4px;\n    top: -3px;\n    background-color: rgb(241, 241, 241);\n    transition: all 0.35s ease 0s;\n    border-radius: 50%;\n  }\n"]);

  _templateObject53 = function _templateObject53() {
    return data;
  };

  return data;
}

function _templateObject52() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject52 = function _templateObject52() {
    return data;
  };

  return data;
}

function _templateObject51() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  max-width: 480px;\n  width: 100%;\n"]);

  _templateObject51 = function _templateObject51() {
    return data;
  };

  return data;
}

function _templateObject50() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: 5px;\n  span {\n    color: red;\n    font-size: 14px;\n  }\n"]);

  _templateObject50 = function _templateObject50() {
    return data;
  };

  return data;
}

function _templateObject49() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject49 = function _templateObject49() {
    return data;
  };

  return data;
}

function _templateObject48() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject48 = function _templateObject48() {
    return data;
  };

  return data;
}

function _templateObject47() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject47 = function _templateObject47() {
    return data;
  };

  return data;
}

function _templateObject46() {
  var data = _taggedTemplateLiteral(["\n  color: #969698;\n  position: absolute;\n  display: block;\n  font-size: 16px;\n  line-height: 21px;\n  padding-left: 14px;\n  font-weight: 300;\n"]);

  _templateObject46 = function _templateObject46() {
    return data;
  };

  return data;
}

function _templateObject45() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  background-color: #F2F2F5;\n  border-radius: 4px;\n  width: 100%;\n  font-size: 16px;\n  line-height: 21px;\n  padding: 15px;\n  color: #3A3A3A;\n  font-family: inherit;\n  font-weight: 300;\n  height: 50px;\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-family: \"maison_neuebook\", helvetica, sans-serif;\n"]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  word-break: break-word;\n"]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 1em;\n  flex-shrink: 0;\n"]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  margin: 0 auto;\n  display: flex;\n  top: 0;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.26);\n  justify-content: center;\n  align-items: center;\n  border-radius: ", ";\n  padding: 1em;\n  max-width: ", ";\n  background-color: ", ";\n  color: ", ";\n"]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  position: fixed;\n  left: 0;\n  z-index: ", ";\n  padding-left: 1em;\n  padding-right: 1em;\n  max-width: 480px;\n  left: 50%;\n  transform: translateX(-50%);\n"]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  margin: ", ";\n  font-size: ", ";\n  background-color: ", ";\n  color: ", ";\n  display: block;\n  border: none;\n  line-height: 17px;\n  font-weight: bold;\n  width: 100%;\n  padding: 7px 0;\n  border-radius: 4px;\n  &:focus {\n    outline: none;\n  }\n  &:disabled {\n    background-color: ", ";\n    color: #989898;\n  }\n"]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid #e8e8e8;\n"]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n  color: #ffffff;\n  text-align: center;\n  padding: 7px;\n  margin-top: 12px;\n  background-color:\n    ", ";\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 12px;\n  border-radius: ", ";\n"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n      text-align: right;\n    "]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  font-size: 10.5px;\n  flex-direction: column;\n  :nth-child(1) {\n    font-weight: 500;\n    color: ", ";\n  }\n  :nth-child(2) {\n    font-weight: 600;\n    margin-left: 4px;\n    ", "\n  }\n"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display:flex;\n  justify-content: space-between;\n  margin-top: 0.25em;\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n    padding: 9.5px;\n    min-height: 175px;\n  "]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex: 1 1 0%;\n\n  ", "\n"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n    height: 100px;\n    object-fit: cover;\n    border-radius: 4px 0;\n  "]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n    border-radius: 4px;\n  "]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  border-radius: 4px;\n\n  ", "\n\n  ", "\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n    border-radius: 4px;\n    margin: 0;\n    flex: 1;\n  "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n    padding-right: 16px;\n  "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  z-index: 0;\n  margin: 0px 20px 0px 0px;\n  flex: 1 1 0%;\n\n  ", "\n\n  ", "\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n    padding-bottom: 1em;\n\n    &:last-of-type {\n      border-bottom: 0;\n      padding-bottom: 0;\n    }\n  "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n    flex-basis: 0;\n    flex-grow: 1;\n    display: block;\n    margin: 0px 10px 10px 0px;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    min-width: 180px;\n    padding: 0;\n  "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  background-color: ", ";\n  margin: 1em 0em;\n  padding-bottom: 1em;\n  line-height: 1.25em;\n  border-bottom: 1px solid #e8e8e8;\n  position: relative;\n\n  ", "\n\n  ", "\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  padding: 0.25em 1em;\n  background-color: ", ";\n  color: ", ";\n  font-size: 12px;\n  font-weight: 600;\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  min-height: ", ";\n  margin: ", ";\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    color: #FFFFFF;\n    background-color: transparent;\n    border: 0px;\n    display: none;\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    color: #DA326B;\n    background-color: #FFFFFF;\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0.5em;\n  bottom: 0.5em;\n  border-radius: 50%;\n  height: 25px;\n  width: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 0.25em;\n  &:focus {\n    outline: none;\n  }\n  ", "\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      max-width: ", ";\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  vertical-align: middle;\n  font-size: 10px;\n  margin: 0.25em 0em;\n  color: ", ";\n  align-items: center;\n  span {\n    ", "\n  }\n  img {\n    height: 12px;\n    margin-left: 0.25em;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 12px;\n  color: ", ";\n  margin-bottom: 0.25em;\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: ", "%;\n  height: 100%;\n  background-color: ", ";\n  border-radius: 2px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 3px;\n  background-color: rgba(0,0,0,0.1);\n  border-radius: 2px;\n  box-shadow: inset 0 0 #000;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n.swiper-container {\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0 0 30px 0;\n  padding-top: 56.25%;\n  width: 100%;\n  //min-height: 270px;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n}\n\n.swiper-container-no-flexbox .swiper-slide {\n  float: left;\n}\n\n.swiper-container-vertical > .swiper-wrapper {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.swiper-wrapper {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  -o-transition-property: transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.swiper-container-android .swiper-slide, .swiper-wrapper {\n  -webkit-transform: translate3d(0px, 0, 0);\n  transform: translate3d(0px, 0, 0);\n}\n\n.swiper-container-multirow > .swiper-wrapper {\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.swiper-container-free-mode > .swiper-wrapper {\n  -webkit-transition-timing-function: ease-out;\n  -o-transition-timing-function: ease-out;\n  transition-timing-function: ease-out;\n  margin: 0 auto;\n}\n\n.swiper-slide {\n  -webkit-flex-shrink: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  max-height: 270px;\n  position: relative;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  -o-transition-property: transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n}\n\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n\n/* Auto Height */\n\n.swiper-container-autoheight {\n  height: auto;\n  .swiper-slide {\n    height: auto;\n  }\n  .swiper-wrapper {\n    -webkit-box-align: start;\n    -webkit-align-items: flex-start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-transition-property: height, -webkit-transform;\n    transition-property: height, -webkit-transform;\n    -o-transition-property: transform, height;\n    transition-property: transform, height;\n    transition-property: transform, height, -webkit-transform;\n  }\n}\n\n/* 3D Effects */\n\n.swiper-container-3d {\n  -webkit-perspective: 1200px;\n  perspective: 1200px;\n  .swiper-wrapper, .swiper-slide, .swiper-slide-shadow-left, .swiper-slide-shadow-right, .swiper-slide-shadow-top, .swiper-slide-shadow-bottom, .swiper-cube-shadow {\n    -webkit-transform-style: preserve-3d;\n    transform-style: preserve-3d;\n  }\n  .swiper-slide-shadow-left, .swiper-slide-shadow-right, .swiper-slide-shadow-top, .swiper-slide-shadow-bottom {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 10;\n  }\n  .swiper-slide-shadow-left {\n    background-image: -webkit-gradient(linear, right top, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n    background-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n    background-image: -o-linear-gradient(right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-slide-shadow-right {\n    background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n    background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n    background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-slide-shadow-top {\n    background-image: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n    background-image: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n    background-image: -o-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-slide-shadow-bottom {\n    background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n    background-image: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n    background-image: -o-linear-gradient(top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n}\n\n/* IE10 Windows Phone 8 Fixes */\n\n.swiper-container-wp8-horizontal {\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  > .swiper-wrapper {\n    -ms-touch-action: pan-y;\n    touch-action: pan-y;\n  }\n}\n\n.swiper-container-wp8-vertical {\n  -ms-touch-action: pan-x;\n  touch-action: pan-x;\n  > .swiper-wrapper {\n    -ms-touch-action: pan-x;\n    touch-action: pan-x;\n  }\n}\n\n.swiper-button-prev, .swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: 27px;\n  height: 44px;\n  margin-top: -22px;\n  z-index: 10;\n  cursor: pointer;\n  background-size: 27px 44px;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled {\n  opacity: 0.35;\n  cursor: auto;\n  pointer-events: none;\n}\n\n.swiper-button-prev, .swiper-container-rtl .swiper-button-next {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");\n  left: 10px;\n  right: auto;\n}\n\n.swiper-button-next, .swiper-container-rtl .swiper-button-prev {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");\n  right: 10px;\n  left: auto;\n}\n\n.swiper-button-prev.swiper-button-white, .swiper-container-rtl .swiper-button-next.swiper-button-white {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\");\n}\n\n.swiper-button-next.swiper-button-white, .swiper-container-rtl .swiper-button-prev.swiper-button-white {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\");\n}\n\n.swiper-button-prev.swiper-button-black, .swiper-container-rtl .swiper-button-next.swiper-button-black {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\");\n}\n\n.swiper-button-next.swiper-button-black, .swiper-container-rtl .swiper-button-prev.swiper-button-black {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\");\n}\n\n.swiper-button-lock {\n  display: none;\n}\n\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  -webkit-transition: 300ms opacity;\n  -o-transition: 300ms opacity;\n  transition: 300ms opacity;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  &.swiper-pagination-hidden {\n    opacity: 0;\n  }\n}\n\n/* Common Styles */\n\n.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n}\n\n/* Bullets */\n\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n  .swiper-pagination-bullet {\n    -webkit-transform: scale(0.33);\n    -ms-transform: scale(0.33);\n    transform: scale(0.33);\n    position: relative;\n  }\n  .swiper-pagination-bullet-active, .swiper-pagination-bullet-active-main {\n    -webkit-transform: scale(1);\n    -ms-transform: scale(1);\n    transform: scale(1);\n  }\n  .swiper-pagination-bullet-active-prev {\n    -webkit-transform: scale(0.66);\n    -ms-transform: scale(0.66);\n    transform: scale(0.66);\n  }\n  .swiper-pagination-bullet-active-prev-prev {\n    -webkit-transform: scale(0.33);\n    -ms-transform: scale(0.33);\n    transform: scale(0.33);\n  }\n  .swiper-pagination-bullet-active-next {\n    -webkit-transform: scale(0.66);\n    -ms-transform: scale(0.66);\n    transform: scale(0.66);\n  }\n  .swiper-pagination-bullet-active-next-next {\n    -webkit-transform: scale(0.33);\n    -ms-transform: scale(0.33);\n    transform: scale(0.33);\n  }\n}\n\n.swiper-pagination-bullet {\n  display: inline-flex;\n  background: #E8E8E8;\n  width: 6px;\n  cursor: pointer;\n  border: 0px;\n  color: white;\n  cursor: pointer;\n  margin: 4px;\n  padding: 0px;\n  outline: 0px;\n  font-size: 24px;\n  height: 6px;\n  border-radius: 100px;\n  transition: all 0.25s ease 0s;\n  text-indent: -9999em;\n}\n\nbutton.swiper-pagination-bullet {\n  border: none;\n  margin: 0;\n  padding: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.swiper-pagination-clickable .swiper-pagination-bullet {\n  cursor: pointer;\n}\n\n.swiper-pagination-bullet-active {\n  display: inline-flex;\n  background-color: #1D68B1;\n  width: 14px;\n  cursor: pointer;\n  border: 0px;\n  color: white;\n  cursor: pointer;\n  margin: 4px;\n  padding: 0px;\n  outline: 0px;\n  font-size: 24px;\n  height: 6px;\n  border-radius: 100px;\n  transition: all 0.25s ease 0s;\n}\n\n.swiper-container-vertical > .swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  -webkit-transform: translate3d(0px, -50%, 0);\n  transform: translate3d(0px, -50%, 0);\n  .swiper-pagination-bullet {\n    margin: 6px 0;\n    display: block;\n  }\n  &.swiper-pagination-bullets-dynamic {\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    width: 8px;\n    .swiper-pagination-bullet {\n      display: inline-block;\n      -webkit-transition: 200ms top, 200ms -webkit-transform;\n      transition: 200ms top, 200ms -webkit-transform;\n      -o-transition: 200ms transform, 200ms top;\n      transition: 200ms transform, 200ms top;\n      transition: 200ms transform, 200ms top, 200ms -webkit-transform;\n    }\n  }\n}\n\n.swiper-container-horizontal {\n  > .swiper-pagination-bullets {\n    .swiper-pagination-bullet {\n      margin: 0 4px;\n    }\n    &.swiper-pagination-bullets-dynamic {\n      left: 50%;\n      -webkit-transform: translateX(-50%);\n      -ms-transform: translateX(-50%);\n      transform: translateX(-50%);\n      white-space: nowrap;\n      .swiper-pagination-bullet {\n        -webkit-transition: 200ms left, 200ms -webkit-transform;\n        transition: 200ms left, 200ms -webkit-transform;\n        -o-transition: 200ms transform, 200ms left;\n        transition: 200ms transform, 200ms left;\n        transition: 200ms transform, 200ms left, 200ms -webkit-transform;\n      }\n    }\n  }\n  &.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    -webkit-transition: 200ms right, 200ms -webkit-transform;\n    transition: 200ms right, 200ms -webkit-transform;\n    -o-transition: 200ms transform, 200ms right;\n    transition: 200ms transform, 200ms right;\n    transition: 200ms transform, 200ms right, 200ms -webkit-transform;\n  }\n}\n\n/* Progress */\n\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute;\n  .swiper-pagination-progressbar-fill {\n    background: #007aff;\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    -webkit-transform: scale(0);\n    -ms-transform: scale(0);\n    transform: scale(0);\n    -webkit-transform-origin: left top;\n    -ms-transform-origin: left top;\n    transform-origin: left top;\n  }\n}\n\n.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  -webkit-transform-origin: right top;\n  -ms-transform-origin: right top;\n  transform-origin: right top;\n}\n\n.swiper-container-horizontal > .swiper-pagination-progressbar {\n  width: 100%;\n  height: 4px;\n  left: 0;\n  top: 0;\n}\n\n.swiper-container-vertical > .swiper-pagination-progressbar {\n  &.swiper-pagination-progressbar-opposite {\n    width: 100%;\n    height: 4px;\n    left: 0;\n    top: 0;\n  }\n  width: 4px;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n\n.swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 4px;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n\n.swiper-pagination-white .swiper-pagination-bullet-active {\n  background: #ffffff;\n}\n\n.swiper-pagination-progressbar.swiper-pagination-white {\n  background: rgba(255, 255, 255, 0.25);\n  .swiper-pagination-progressbar-fill {\n    background: #ffffff;\n  }\n}\n\n.swiper-pagination-black .swiper-pagination-bullet-active {\n  background: #000000;\n}\n\n.swiper-pagination-progressbar.swiper-pagination-black {\n  background: rgba(0, 0, 0, 0.25);\n  .swiper-pagination-progressbar-fill {\n    background: #000000;\n  }\n}\n\n.swiper-pagination-lock {\n  display: none;\n}\n\n/* Scrollbar */\n\n.swiper-scrollbar {\n  border-radius: 10px;\n  position: relative;\n  -ms-touch-action: none;\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.swiper-container-horizontal > .swiper-scrollbar {\n  position: absolute;\n  left: 1%;\n  bottom: 3px;\n  z-index: 50;\n  height: 5px;\n  width: 98%;\n}\n\n.swiper-container-vertical > .swiper-scrollbar {\n  position: absolute;\n  right: 3px;\n  top: 1%;\n  z-index: 50;\n  width: 5px;\n  height: 98%;\n}\n\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 10px;\n  left: 0;\n  top: 0;\n}\n\n.swiper-scrollbar-cursor-drag {\n  cursor: move;\n}\n\n.swiper-scrollbar-lock {\n  display: none;\n}\n\n.swiper-zoom-container {\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  text-align: center;\n  > {\n    img, svg, canvas {\n      max-width: 100%;\n      max-height: 100%;\n      -o-object-fit: contain;\n      object-fit: contain;\n    }\n  }\n}\n\n.swiper-slide-zoomed {\n  cursor: move;\n}\n\n/* Preloader */\n\n.swiper-lazy-preloader {\n  position: absolute;\n  background-color: #f3f3f3;\n  top: 50%;\n  left: 50%;\n  text-indent: -9999px;\n  -webkit-transform: translate(-50%,-50%);\n  -ms-transform: translate(-50%,-50%);\n  transform: translate(-50%,-50%);\n  border-radius: 5px;\n  max-height: 100%;\n  height: 90%;\n  max-width: 100%;\n  width: 100%;\n  //width: 42px;\n  //height: 42px;\n  //position: absolute;\n  //left: 50%;\n  //top: 50%;\n  //margin-left: -21px;\n  //margin-top: -21px;\n  //z-index: 10;\n  //-webkit-transform-origin: 50%;\n  //-ms-transform-origin: 50%;\n  //transform-origin: 50%;\n  //-webkit-animation: swiper-preloader-spin 1s steps(12, end) infinite;\n  //animation: swiper-preloader-spin 1s steps(12, end) infinite;\n  //&:after {\n    //display: block;\n    //content: '';\n    //width: 100%;\n    //height: 100%;\n    //background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%236c6c6c'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n    //background-position: 50%;\n    //background-size: 100%;\n    //background-repeat: no-repeat;\n  //}\n}\nimg.swiper-lazy-loaded {\n    display: block;\n}\n.swiper-lazy-preloader-white:after {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%23fff'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n\n@-webkit-keyframes swiper-preloader-spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n\n@keyframes swiper-preloader-spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n\n/* a11y */\n\n.swiper-container .swiper-notification {\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: -1000;\n}\n\n.swiper-container-fade {\n  &.swiper-container-free-mode .swiper-slide {\n    -webkit-transition-timing-function: ease-out;\n    -o-transition-timing-function: ease-out;\n    transition-timing-function: ease-out;\n  }\n  .swiper-slide {\n    pointer-events: none;\n    -webkit-transition-property: opacity;\n    -o-transition-property: opacity;\n    transition-property: opacity;\n    .swiper-slide {\n      pointer-events: none;\n    }\n  }\n  .swiper-slide-active {\n    pointer-events: auto;\n    .swiper-slide-active {\n      pointer-events: auto;\n    }\n  }\n}\n\n.swiper-container-cube {\n  overflow: visible;\n  .swiper-slide {\n    pointer-events: none;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    z-index: 1;\n    visibility: hidden;\n    -webkit-transform-origin: 0 0;\n    -ms-transform-origin: 0 0;\n    transform-origin: 0 0;\n    width: 100%;\n    height: 100%;\n    .swiper-slide {\n      pointer-events: none;\n    }\n  }\n  &.swiper-container-rtl .swiper-slide {\n    -webkit-transform-origin: 100% 0;\n    -ms-transform-origin: 100% 0;\n    transform-origin: 100% 0;\n  }\n  .swiper-slide-active {\n    pointer-events: auto;\n    .swiper-slide-active {\n      pointer-events: auto;\n    }\n    pointer-events: auto;\n    visibility: visible;\n  }\n  .swiper-slide-next, .swiper-slide-prev, .swiper-slide-next + .swiper-slide {\n    pointer-events: auto;\n    visibility: visible;\n  }\n  .swiper-slide-shadow-top, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left, .swiper-slide-shadow-right {\n    z-index: 0;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n  }\n  .swiper-cube-shadow {\n    position: absolute;\n    left: 0;\n    bottom: 0px;\n    width: 100%;\n    height: 100%;\n    background: #000;\n    opacity: 0.6;\n    -webkit-filter: blur(50px);\n    filter: blur(50px);\n    z-index: 0;\n  }\n}\n\n.swiper-container-flip {\n  overflow: visible;\n  .swiper-slide {\n    pointer-events: none;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    z-index: 1;\n    .swiper-slide {\n      pointer-events: none;\n    }\n  }\n  .swiper-slide-active {\n    pointer-events: auto;\n    .swiper-slide-active {\n      pointer-events: auto;\n    }\n  }\n  .swiper-slide-shadow-top, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left, .swiper-slide-shadow-right {\n    z-index: 0;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n  }\n}\n\n.swiper-container-coverflow .swiper-wrapper {\n  /* Windows 8 IE 10 fix */\n  -ms-perspective: 1200px;\n}\n\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n          display: inline-flex;\n          background: white;\n          width: 6px;\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n          display: inline-flex;\n          background: rgb(0, 174, 239);\n          width: 14px;\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  cursor: pointer;\n  border: 0px;\n  color: white;\n  cursor: pointer;\n  margin: 4px;\n  padding: 0px;\n  outline: 0px;\n  font-size: 24px;\n  height: 6px;\n  border-radius: 100px;\n  transition: all 0.25s ease 0s;\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px 0px;\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  bottom: 5%;\n  transform: translate(-50%);\n  ul {\n    position: relative;\n    margin: 0px;\n    padding: 0px;\n    li {\n      list-style-type: none;\n      display: inline;\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  background-color: #f3f3f3;\n  top: 50%;\n  left: 50%;\n  display: none;\n  width: auto;\n  max-width: 100%;\n  height: auto;\n  max-height: 100%;\n  text-indent: -9999px;\n  transform: translate(-50%, -50%);\n  border-radius: 5px;\n  height: auto;\n  max-width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  text-decoration: none;\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  //height: 272px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React__default, { createElement, useState } from 'react';
import Swiper from 'react-id-swiper';
import ContentLoader from 'react-content-loader';
import styled, { css, createGlobalStyle } from 'styled-components';
import { getImgixUrl, currencyFormatter } from '@3pp/utils';
import LoveActive from '@kitabisa/icons/dist/LoveActive';
import LoveOutline from '@kitabisa/icons/dist/LoveOutline';
import { space, width } from 'styled-system';
import { Transition } from 'react-transition-group';
import CloseCrossLightOutline from '@kitabisa/icons/dist/CloseCrossLightOutline';
import CheckOutline from '@kitabisa/icons/dist/CheckOutline';
import SearchLightOutline from '@kitabisa/icons/dist/SearchLightOutline';
var CarouselContainer = styled.div(_templateObject());
var CarouselImageContainer = styled.div(_templateObject2());
var CarouselLink = styled.a(_templateObject3());
var CarouselImage = styled.img(_templateObject4());
var PaginationContainer = styled.div(_templateObject5());
var PaginationButton = styled.div(_templateObject6(), function (props) {
  return props.isActive ? css(_templateObject7()) : css(_templateObject8());
});
var GlobalStyle = createGlobalStyle(_templateObject9());

var Carousel = function Carousel(_ref) {
  var loading = _ref.loading,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$interval = _ref.interval,
      interval = _ref$interval === void 0 ? 5000 : _ref$interval;

  var onClickBanner = function onClickBanner(index) {
    var currentData = data[index];
    onClick(index);

    if (currentData.url && currentData.url !== '') {
      window.location.href = currentData.url;
    }
  };

  var params = {
    lazy: true,
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: interval,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function renderBullet(index, className) {
        return '<span class="' + className + '">' + (index + 1) + '</span>';
      }
    }
  };

  if (loading) {
    return React__default.createElement(CarouselContainer, {
      style: {
        marginTop: 14
      }
    }, React__default.createElement(ContentLoader, {
      height: 268,
      width: 448,
      speed: 2
    }, React__default.createElement("rect", {
      x: "188",
      y: "17",
      rx: "0",
      ry: "0",
      width: "0",
      height: "0"
    }), React__default.createElement("rect", {
      x: "2",
      y: "2",
      rx: "0",
      ry: "0",
      width: "515",
      height: "320"
    })));
  }

  return React__default.createElement(CarouselContainer, null, React__default.createElement(GlobalStyle, null), React__default.createElement(Swiper, Object.assign({}, params), data.map(function (item, index) {
    return React__default.createElement(CarouselImageContainer, {
      key: item.id
    }, React__default.createElement(CarouselLink, {
      id: item.id,
      onClick: function onClick() {
        return onClickBanner(index);
      }
    }, React__default.createElement(CarouselImage, {
      "data-src": "".concat(item.image, "?ar=16:9&w=448&fit=crop"),
      className: "swiper-lazy",
      alt: "img"
    }), React__default.createElement("div", {
      className: "swiper-lazy-preloader swiper-lazy-preloader-white"
    })));
  })));
}; // Carousel.propTypes = {
//   /** need id for automation testing */
//   id: PropTypes.string,
//   /** interval is props with types number that make delay between auto play transitions (in ms). */
//   interval: PropTypes.number.isRequired,
//   /** data is prop with types array that received image-url data */
//   data: PropTypes.array
// }
// export default Carousel
// this color is base color of Progress Bar


var Track = styled.div(_templateObject10()); // this the filler color is Primary, Pink, Green of Progress Bar Colors

var Filler = styled.div(_templateObject11(), function (props) {
  return props.percentage >= 100 ? 100 : props.percentage;
}, function (props) {
  return props.color === 'primary' && '#00aeef' || props.color === 'pink' && '#da336b' || props.color === 'green' && '#6ad248' || '#00aeef';
});

var ProgressBar = function ProgressBar(props) {
  return React__default.createElement(Track, null, React__default.createElement(Filler, {
    color: props.color,
    percentage: props.percentage
  }));
};

var iconBadges = function iconBadges(type) {
  switch (type) {
    case 'ORGANIZATION':
      return 'https://assets.kitabisa.cc/images/icons/icon__verified-org.svg';

    case 'CORPORATE':
      return 'https://assets.kitabisa.cc/images/icons/icon__verified-corp.svg';

    default:
      return 'https://assets.kitabisa.cc/images/icons/icon__verified-user.svg';
  }
};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var es5 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  var theme = {
    clrBrand01: '#00aeef',
    clrBrand02: '#da336b',
    clrBrand03: '#6ad248',
    clrTitleText: '#3a3a3a',
    clrBaseParagraph: '#4a4a4a',
    clrSubText: '#989898',
    clrLinkText: '#00aeef',
    clrSecondaryLabel: '#da336b',
    clrInverseText: 'white',
    clrField01: '#e7f5ff',
    clrField02: '#f2f3f4',
    clrField03: '#fafafa',
    clrField04: '#ffffff',
    clrField05: '#f7f7f7',
    clrBorder01: '#d8d8d8',
    clrBorder02: '#e8e8e8',
    clrAdd01: '#e7f5ff',
    clrAdd02: '#fff7c2',
    clrAdd03: '#e5f5e7',
    clrAdd04: '#f80505',
    clrFacebook: '#3b5999',
    clrLinkedIn: '#0077b5',
    clrTwitter: '#55acee',
    clrWhatsApp: '#25d366',
    clrLine: '#00c300',
    clrYahoo: '#410093',
    clrGooglePlus: '#dd4b39',
    clrDribbble: '#ea4c89',
    clrYoutube: '#ff0000',
    brandColors: {
      primary: '#00aeef',
      secondary: '#da336b',
      tersier: '#6ad248',
      info: '#e7f5ff',
      warning: '#fff7c2',
      success: '#e5f5e7',
      danger: '#f80505'
    },
    textColors: {
      base: '#4a4a4a',
      primary: '#00aeef',
      secondary: '#da336b',
      inverse: 'white',
      title: '#3a3a3a',
      subText: '#989898'
    },
    clrBlack: {
      black10: 'rgba(0,0,0,0.1)',
      black20: 'rgba(0,0,0,0.2)',
      black30: 'rgba(0,0,0,0.3)',
      black40: 'rgba(0,0,0,0.4)',
      black50: 'rgba(0,0,0,0.5)',
      black60: 'rgba(0,0,0,0.6)',
      black70: 'rgba(0,0,0,0.7)',
      black80: 'rgba(0,0,0,0.8)',
      black90: 'rgba(0,0,0,0.9)'
    }
  };
  exports.default = theme;
  exports.theme = theme;
});
var theme = unwrapExports(es5);
var es5_1 = es5.theme;
var CardTitle = styled.span(_templateObject12(), theme.clrBaseParagraph, function (props) {
  return props.lineClamp;
});
var CardSubtitle = styled.div(_templateObject13(), theme.clrBlack.black80, function (props) {
  return props.maxWidth ? css(_templateObject14(), function (props) {
    return props.maxWidth;
  }) : css(_templateObject15());
});
var CardLoveCampaign = styled.button(_templateObject16(), function (props) {
  return props.isLoved ? css(_templateObject17()) : css(_templateObject18());
});
var CardItemContent = styled.div(_templateObject19(), function (props) {
  return props.minHeight;
}, function (props) {
  return props.margin;
});
var CardTag = styled.div(_templateObject20(), function (props) {
  return props.color === 'gray' && theme.clrBlack.black20 || props.color === 'blue' && theme.clrBrand01 || props.color === 'pink' && theme.clrBrand02 || props.color === 'zakatGreen' && props.theme.clrBrand03 || theme.clrBrand03;
}, function (props) {
  return props.color === 'gray' && theme.clrBlack.black80 || theme.clrField04;
});
var ListContainer = styled.div(_templateObject21(), theme.clrInverseText, function (props) {
  return props.type === 'sliderItem' && css(_templateObject22());
}, function (props) {
  return props.type === 'listItem' && css(_templateObject23());
});
var ListFigureCanvas = styled.figure(_templateObject24(), function (props) {
  return props.type === 'listItem' && css(_templateObject25());
}, function (props) {
  return props.type === 'sliderItem' && css(_templateObject26());
});
var ListImageCanvas = styled.img(_templateObject27(), function (props) {
  return props.type === 'listItem' && css(_templateObject28());
}, function (props) {
  return props.type === 'sliderItem' && css(_templateObject29());
});
var ListContent = styled.div(_templateObject30(), function (props) {
  return props.type === 'sliderItem' && css(_templateObject31());
});
var ListCount = styled.div(_templateObject32());
var ListCountItem = styled.div(_templateObject33(), theme.textColors.base, function (props) {
  return props.type === 'dayLeft' && css(_templateObject34());
});
var ListPermalink = styled.a(_templateObject35());
var ListDonateLink = styled.a(_templateObject36(), function (props) {
  return props.btnColor ? props.btnColor : '#00aeef';
}, function (props) {
  return props.borderRadius ? props.borderRadius : '4px';
});
var ListBorder = styled.hr(_templateObject37());

var ListCard = function ListCard(_ref2) {
  var props = Object.assign({}, _ref2);
  return React__default.createElement(ListContainer, {
    type: props.type,
    "data-testid": props.dataTestId
  }, React__default.createElement(ListFigureCanvas, {
    type: props.type
  }, React__default.createElement(CardLoveCampaign, {
    isLoved: props.isLoved
  }, props.isLoved ? React__default.createElement(LoveActive, null) : React__default.createElement(LoveOutline, null)), props.tag && React__default.createElement(CardTag, {
    color: props.tag.color
  }, props.tag.text), React__default.createElement(ListImageCanvas, {
    alt: props.image.name,
    src: getImgixUrl(props.image.url),
    type: props.type
  })), React__default.createElement(ListContent, {
    type: props.type
  }, React__default.createElement(CardTitle, {
    lineClamp: 2
  }, props.title), React__default.createElement(CardSubtitle, {
    maxWidth: "110px"
  }, React__default.createElement("span", null, props.campaigner.name), props.isVerified && React__default.createElement("img", {
    src: iconBadges(props.campaigner.type),
    alt: "verified badge"
  })), React__default.createElement(CardItemContent, {
    margin: '0.25em 0em'
  }, React__default.createElement(ProgressBar, {
    color: props.progressBar.color,
    percentage: props.progressBar.percentage
  })), React__default.createElement(ListCount, null, React__default.createElement(ListCountItem, {
    type: "donationCollected"
  }, React__default.createElement("span", null, "Terkumpul"), React__default.createElement("span", null, React__default.createElement("strong", null, "Rp ", currencyFormatter(props.donationCollected)))), props.type !== 'sliderItem' && React__default.createElement(ListCountItem, {
    type: "dayLeft"
  }, React__default.createElement("span", null, "Sisa hari"), React__default.createElement("span", null, props.remainingDays))), props.type === 'sliderItem' && React__default.createElement(ListDonateLink, {
    btnColor: props.btnColor,
    borderRadius: props.borderRadius
  }, "Donasi")), React__default.createElement(ListPermalink, {
    href: props.permalink,
    onClick: props.onClick,
    "aria-label": props.title
  }));
};

var colors = {
  primary: '#00aeef',
  secondary: '#da336b',
  disabled: '#F2F3F4'
};
/* eslint-disable @typescript-eslint/no-explicit-any */

var ButtonStyle = css(_templateObject38(), function (props) {
  return props.height ? props.height : 'initial';
}, function (props) {
  return props.margin ? props.margin : '0';
}, function (props) {
  return props.fontSize ? props.fontSize : '12px';
}, function (props) {
  return props.backgroundColor ? props.backgroundColor : colors.primary;
}, function (props) {
  return props.color ? props.color : "#fff";
}, function (props) {
  return props.backgroundColorDisabled ? props.backgroundColorDisabled : colors.disabled;
});
var Wrapper = styled.button(_templateObject39(), ButtonStyle, space, width);

var Button = function Button(props) {
  return createElement(Wrapper, Object.assign({
    style: props.style,
    "aria-label": props.label
  }, props), props.children ? props.children : props.label);
};

var theme$1 = {
  clrBrand01: '#00aeef',
  clrBrand02: '#da336b',
  clrBrand03: '#6ad248',
  clrTitleText: '#3a3a3a',
  clrBaseParagraph: '#4a4a4a',
  clrSubText: '#989898',
  clrLinkText: '#00aeef',
  clrSecondaryLabel: '#da336b',
  clrInverseText: 'white',
  clrField01: '#e7f5ff',
  clrField02: '#f2f3f4',
  clrField03: '#fafafa',
  clrField04: '#ffffff',
  clrField05: '#f7f7f7',
  clrBorder01: '#d8d8d8',
  clrBorder02: '#e8e8e8',
  clrAdd01: '#e7f5ff',
  clrAdd02: '#fff7c2',
  clrAdd03: '#e5f5e7',
  clrAdd04: '#f80505',
  clrFacebook: '#3b5999',
  clrLinkedIn: '#0077b5',
  clrTwitter: '#55acee',
  clrWhatsApp: '#25d366',
  clrLine: '#00c300',
  clrYahoo: '#410093',
  clrGooglePlus: '#dd4b39',
  clrDribbble: '#ea4c89',
  clrYoutube: '#ff0000',
  brandColors: {
    primary: '#00aeef',
    secondary: '#da336b',
    tersier: '#6ad248',
    info: '#e7f5ff',
    warning: '#fff7c2',
    success: '#e5f5e7',
    danger: '#f80505'
  },
  textColors: {
    base: '#4a4a4a',
    primary: '#00aeef',
    secondary: '#da336b',
    inverse: 'white',
    title: '#3a3a3a',
    subText: '#989898'
  },
  clrBlack: {
    black10: 'rgba(0,0,0,0.1)',
    black20: 'rgba(0,0,0,0.2)',
    black30: 'rgba(0,0,0,0.3)',
    black40: 'rgba(0,0,0,0.4)',
    black50: 'rgba(0,0,0,0.5)',
    black60: 'rgba(0,0,0,0.6)',
    black70: 'rgba(0,0,0,0.7)',
    black80: 'rgba(0,0,0,0.8)',
    black90: 'rgba(0,0,0,0.9)'
  }
};
var boxColors = {
  blue: '#E5F0F5',
  green: '#E5F5E7',
  orange: '#FFC685',
  red: '#FF5050',
  black: 'rgba(0,0,0,0.7);'
};
var FlashMessageWrapper = styled.div(_templateObject40(), function (props) {
  return props.show ? 16 : 10;
});
var FlashMessageContent = styled.div(_templateObject41(), function (props) {
  return props.isCapsule ? '100px' : '3px';
}, function (props) {
  return props.maxWidth || 'none';
}, function (props) {
  return boxColors[props.colorType];
}, function (props) {
  return props.colorType === 'black' ? 'white' : theme$1.clrBaseParagraph;
});
var FlashMessageIconContainer = styled.div(_templateObject42());
var FlashMessageText = styled.span(_templateObject43());
var DURATION = 300;

var FlashMessage = function FlashMessage(_ref3) {
  var inProp = _ref3.inProp,
      colorType = _ref3.colorType,
      icon = _ref3.icon,
      text = _ref3.text,
      defaultStyle = _ref3.defaultStyle,
      enterStyle = _ref3.enterStyle,
      exitStyle = _ref3.exitStyle,
      isCapsule = _ref3.isCapsule;
  var transitionStyles = {
    entering: enterStyle,
    entered: enterStyle,
    exiting: exitStyle,
    exited: exitStyle
  };
  return React__default.createElement(Transition, {
    in: inProp,
    timeout: 300
  }, function (state) {
    return React__default.createElement(FlashMessageWrapper, {
      show: inProp,
      style: _objectSpread({}, defaultStyle, {}, transitionStyles[state])
    }, React__default.createElement(FlashMessageContent, {
      colorType: colorType,
      isCapsule: isCapsule
    }, React__default.createElement(FlashMessageIconContainer, null, icon), React__default.createElement(FlashMessageText, null, text)));
  });
};

FlashMessage.defaultProps = {
  colorType: 'blue',
  defaultStyle: {
    transition: "all ".concat(DURATION, "ms ease-in-out"),
    top: '10px',
    opacity: 0
  },
  enterStyle: {
    opacity: 1,
    top: '70px'
  },
  exitStyle: {
    opacity: 0,
    top: '10px'
  }
};
var WrapperStyle = css(_templateObject44());
var InputStyle = css(_templateObject45());
var PrefixStyle = css(_templateObject46());
var Wrapper$1 = styled.div(_templateObject47(), WrapperStyle, space, width);
var TextInput = styled.input(_templateObject48(), InputStyle);
var Prefix = styled.div(_templateObject49(), PrefixStyle);
var Error = styled.div(_templateObject50());

var Input = function Input(_ref4) {
  var prefix = _ref4.prefix,
      suffix = _ref4.suffix,
      value = _ref4.value,
      id = _ref4.id,
      onChangeVal = _ref4.onChangeVal,
      placeholder = _ref4.placeholder,
      style = _ref4.style,
      errorText = _ref4.errorText,
      className = _ref4.className,
      _ref4$type = _ref4.type,
      type = _ref4$type === void 0 ? "text" : _ref4$type,
      rest = _objectWithoutProperties(_ref4, ["prefix", "suffix", "value", "id", "onChangeVal", "placeholder", "style", "errorText", "className", "type"]);

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Wrapper$1, Object.assign({
    key: id
  }, rest), prefix ? React__default.createElement(Prefix, null, prefix) : null, React__default.createElement(TextInput, {
    className: className,
    style: style,
    key: id,
    type: type,
    value: value,
    placeholder: placeholder,
    onChange: function onChange(e) {
      onChangeVal(e.target.value);
    }
  }), suffix ? suffix : null), errorText !== '' ? React__default.createElement(Error, null, React__default.createElement("span", null, errorText)) : null);
};

var LayoutStyle = css(_templateObject51());
var Wrapper$2 = styled.div(_templateObject52(), LayoutStyle, space, width);

var Layout = function Layout(_ref5) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, ["children"]);

  return createElement(Wrapper$2, Object.assign({}, rest), children);
};

var WrapperStyle$1 = css(_templateObject53());
var Wrapper$3 = styled.div(_templateObject54(), WrapperStyle$1);

var SwitchToggle = function SwitchToggle(_ref6) {
  var name = _ref6.name,
      label = _ref6.label,
      _ref6$onChange = _ref6.onChange,
      _onChange = _ref6$onChange === void 0 ? function () {} : _ref6$onChange;

  return React__default.createElement(Wrapper$3, null, React__default.createElement("label", {
    htmlFor: name
  }, label, React__default.createElement("input", {
    id: name,
    type: "checkbox",
    onChange: function onChange(e) {
      _onChange(e.target.checked);
    }
  }), React__default.createElement("span", null)));
};

var LayoutStyle$1 = css(_templateObject55());
var Wrapper$4 = styled.div(_templateObject56(), LayoutStyle$1, space, width);

var Textarea = function Textarea(_ref7) {
  var _onChange2 = _ref7.onChange,
      maxLength = _ref7.maxLength,
      placeholder = _ref7.placeholder;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      length = _useState2[0],
      setLength = _useState2[1];

  return React__default.createElement(Wrapper$4, null, React__default.createElement("textarea", {
    placeholder: placeholder,
    onChange: function onChange(e) {
      setLength(e.currentTarget.value.length);

      _onChange2(e.currentTarget.value);
    },
    maxLength: maxLength
  }), React__default.createElement("span", null, length, "/140"));
};

var Container = styled.div(_templateObject57());
var Section = styled.div(_templateObject58());
var Image = styled.img(_templateObject59());
var Heading = styled.h2(_templateObject60());
var Info = styled.p(_templateObject61());
var Button$1 = styled.button(_templateObject62());

var FailedPage = function FailedPage(_ref8) {
  var _ref8$from = _ref8.from,
      from = _ref8$from === void 0 ? 'https://kitabisa.com' : _ref8$from,
      _ref8$title = _ref8.title,
      title = _ref8$title === void 0 ? 'Oops terjadi kesalahan..' : _ref8$title,
      _ref8$information = _ref8.information,
      information = _ref8$information === void 0 ? 'Hiks sedang ada gangguan sistem, kamu bisa kembali lagi nanti ya.' : _ref8$information,
      _ref8$imgSrc = _ref8.imgSrc,
      imgSrc = _ref8$imgSrc === void 0 ? "https://assets.kitabisa.cc/images/error/404-locker.svg" : _ref8$imgSrc,
      _ref8$imgAlt = _ref8.imgAlt,
      imgAlt = _ref8$imgAlt === void 0 ? "404" : _ref8$imgAlt;
  return React__default.createElement(Container, null, React__default.createElement(Section, null, React__default.createElement(Image, {
    src: imgSrc,
    alt: imgAlt
  }), React__default.createElement(Heading, null, title), React__default.createElement(Info, null, information), React__default.createElement(Button$1, {
    onClick: function onClick() {
      return window.location.href = from;
    }
  }, "Kembali ke halaman depan")));
};

var HeaderWrapper = styled.div(_templateObject63());
var Title = styled.h3(_templateObject64());
var HeaderContent = styled.div(_templateObject65());
var HeaderNav = styled.div(_templateObject66());

var Header = function Header(props) {
  return React__default.createElement(HeaderWrapper, null, React__default.createElement(HeaderContent, null, React__default.createElement(HeaderNav, {
    id: props.id,
    onClick: function onClick() {
      return props.onClick();
    }
  }, React__default.createElement(CloseCrossLightOutline, {
    size: 16
  })), React__default.createElement(Title, null, props.title)));
};

var CheckboxWrapper = styled.div(_templateObject67());
var CheckboxContent = styled.span(_templateObject68());
var CheckboxInput = styled.input(_templateObject69(), CheckboxContent);

var Checkbox = function Checkbox(props) {
  return React__default.createElement(CheckboxWrapper, null, React__default.createElement(CheckboxInput, {
    type: "checkbox",
    id: props.inputId,
    checked: props.checked,
    onChange: props.onChange
  }), React__default.createElement(CheckboxContent, null, React__default.createElement(CheckOutline, null)));
};

var UpsellingBox = styled.div(_templateObject70(), function (props) {
  return props.bgColor;
});
var UpsellingLabel = styled.label(_templateObject71(), function (props) {
  return props.isCentered ? 'center' : 'flex-start';
});
var UpsellingText = styled.div(_templateObject72(), theme.clrBrand01);
var UpsellingDetail = styled.div(_templateObject73());
var Divider = styled.hr(_templateObject74());
var UpsellingDetailText = styled.p(_templateObject75(), theme.clrSubText);
var UpsellingDetailTotal = styled.p(_templateObject76());
var UpsellingImage = styled.div(_templateObject77());
var UpsellingContent = styled.div(_templateObject78());
var UpsellingLearnMoreHead = styled.div(_templateObject79());
var UpsellingLearMoreList = styled.ul(_templateObject80());
var UpsellingLearnMoreText = styled.div(_templateObject81(), theme.clrBrand01, function (props) {
  return props.isAsterisk ? 'inline' : 'none';
});
var UpsellingLearnMoreFooter = styled.p(_templateObject82(), theme.clrBrand01);
var UpsellingBannerContainer = styled.div(_templateObject83());
var UpsellingBannerOverlay = styled.div(_templateObject84());
var UpsellingBannerCloseIcon = styled.span(_templateObject85());
var UpsellingBannerLink = styled.a(_templateObject86());
var UpsellingBannerClose = styled.a(_templateObject87());
var duration = 300;
var defaultStyles = {
  banner: {
    transition: "bottom ".concat(duration, "ms ease-in-out, opacity ").concat(duration * 2, "ms ease-in-out"),
    opacity: 0,
    bottom: '-180px'
  },
  overlay: {
    display: 'block'
  }
};
var transitionStyles = {
  banner: {
    entering: {
      opacity: 1,
      bottom: '0'
    },
    entered: {
      opacity: 1,
      bottom: '0'
    },
    exiting: {
      transitionDelay: '0s',
      opacity: 0,
      bottom: '-180px',
      pointerEvents: 'none'
    },
    exited: {
      opacity: 0,
      bottom: '-180px',
      pointerEvents: 'none'
    }
  },
  overlay: {
    entering: {
      display: 'block'
    },
    entered: {
      display: 'block'
    },
    exiting: {
      display: 'none'
    },
    exited: {
      display: 'none'
    }
  }
};

var LearnMoreBanner = function LearnMoreBanner(_ref9) {
  var isShowed = _ref9.isShowed,
      setIsShowed = _ref9.setIsShowed,
      content = _ref9.content;
  return React__default.createElement(Transition, {
    in: isShowed,
    timeout: duration
  }, function (state) {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(UpsellingBannerOverlay, {
      style: _objectSpread({}, defaultStyles.overlay, {}, transitionStyles.overlay[state]),
      onClick: function onClick() {
        setIsShowed(false)(window).dataLayer.push({
          'event': "contribute/upselling/learnmore/close"
        });
      }
    }), React__default.createElement(UpsellingBannerContainer, {
      style: _objectSpread({}, defaultStyles.banner, {}, transitionStyles.banner[state])
    }, React__default.createElement(UpsellingBannerClose, null, React__default.createElement(UpsellingBannerCloseIcon, {
      onClick: function onClick() {
        setIsShowed(false)(window).dataLayer.push({
          'event': "contribute/upselling/learnmore/close"
        });
      }
    }, React__default.createElement(CloseCrossLightOutline, {
      size: 16
    }))), React__default.createElement(UpsellingLearnMoreHead, null, React__default.createElement("img", {
      src: content.static_card[0].image[0].url,
      alt: ""
    }), React__default.createElement("p", {
      className: "head-title"
    }, content.static_card[0].title)), React__default.createElement("hr", {
      style: {
        opacity: 0.5
      }
    }), React__default.createElement(UpsellingLearMoreList, null, content.static_card[1].image.map(function (item) {
      return React__default.createElement("li", {
        key: item.text
      }, React__default.createElement("img", {
        src: item.url,
        alt: item.text
      }), React__default.createElement(UpsellingLearnMoreText, {
        isAsterisk: item.is_asterisk || false
      }, React__default.createElement("h4", null, item.text), React__default.createElement("p", null, item.desc)));
    })), React__default.createElement("hr", {
      style: {
        opacity: 0.5,
        marginTop: 0
      }
    }), React__default.createElement(UpsellingLearnMoreFooter, null, React__default.createElement("span", {
      className: "asterisk"
    }, "* "), "Syarat dan ketentuan berlaku")));
  });
};
/* eslint-disable @typescript-eslint/no-explicit-any */


var UpsellingProteksi = function UpsellingProteksi(props) {
  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLearnMoreShowed = _useState4[0],
      setIsLearnMoreShowed = _useState4[1];

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(UpsellingBox, {
    bgColor: props.isChecked ? '#dff1ff' : '#f2f3f4'
  }, React__default.createElement(UpsellingContent, null, React__default.createElement(UpsellingLabel, {
    isCentered: props.isCentered
  }, React__default.createElement(Checkbox, {
    inputId: "upselling-checkbox",
    checked: props.isChecked,
    onChange: function onChange() {
      window.dataLayer.push({
        'event': props.gtmEvent
      });
      props.onChange();
    }
  })), React__default.createElement(UpsellingImage, null, React__default.createElement("img", {
    src: props.content.upselling.image,
    alt: "upselling"
  })), React__default.createElement(UpsellingText, null, React__default.createElement("p", null, "".concat(props.content.upselling.desc_text, ". "))))), React__default.createElement(Divider, null), React__default.createElement(UpsellingDetail, null, React__default.createElement(UpsellingDetailText, null, React__default.createElement("span", null, "Donasi Penggalangan Dana"), React__default.createElement("span", null, "Rp ", currencyFormatter(props.donationAmount))), React__default.createElement(UpsellingDetailText, null, React__default.createElement("span", null, "Donasi Kitabisa Plus"), React__default.createElement("span", null, "Rp ", currencyFormatter(props.amount))), React__default.createElement(UpsellingDetailTotal, null, React__default.createElement("span", null, "Total"), React__default.createElement("span", null, "Rp ", currencyFormatter(Number(props.donationAmount) + Number(props.amount))))), React__default.createElement(LearnMoreBanner, {
    isShowed: isLearnMoreShowed,
    setIsShowed: setIsLearnMoreShowed,
    content: props.content
  }));
};

var InputWrapper = styled.div(_templateObject88());
var Input$1 = styled.span(_templateObject89()); // eslint-disable-next-line react/display-name

var index = function index(props) {
  return React__default.createElement(InputWrapper, {
    onClick: props.onClick,
    id: props.id,
    "data-testid": props.dataTestId
  }, React__default.createElement(SearchLightOutline, {
    size: 20
  }), React__default.createElement(Input$1, null, props.children));
};

export { Button, Carousel, Checkbox, FailedPage, FlashMessage, Header, Input, Layout, ListCard, ProgressBar, index as SearchInput, SwitchToggle, Textarea, UpsellingProteksi };